import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'
import TotallySureBadge from '@totallymoney/ui/components/TotallySureBadge'
import theme from '@totallymoney/ui/theme'

import {
    ProductDetail,
    ProductDetailType,
} from '@components/CreditCardContent/components/Content.interface'

import { borderStyle } from '@styles/borderStyle'

const CardPageItemProductDetail = ({
    title,
    value,
    detailType,
}: ProductDetail) => (
    <Box
        as="li"
        display={['flex', 'grid']}
        alignItems="center"
        width="100%"
        gridTemplateColumns="1fr 1fr"
        justifyContent="space-between"
        borderBottom={[borderStyle, 'unset']}
        pb={['space10', 0]}
    >
        <Box mr="space20">
            {typeof title === 'string' ? (
                <Text variant="100" color="light">
                    {title}
                </Text>
            ) : (
                title
            )}
        </Box>

        <Box
            display="flex"
            flexDirection={['column', 'row']}
            justifyContent={['flex-end', 'flex-end', 'flex-start']}
        >
            {typeof value === 'string' ? (
                <Text
                    variant="120"
                    weight="bold"
                    color="light"
                    textAlign="right"
                    style={{ fontFamily: theme.buenosAires }}
                >
                    {value}
                </Text>
            ) : (
                value
            )}

            {detailType === ProductDetailType.GuaranteedExample ||
            detailType === ProductDetailType.GuaranteedCreditLimit ? (
                <Box
                    position="relative"
                    display="flex"
                    flexDirection="column"
                    ml="space10"
                    justifyContent="center"
                    alignSelf={['flex-end', 'center']}
                >
                    <TotallySureBadge text="Guaranteed" />
                </Box>
            ) : null}
        </Box>
    </Box>
)

export default CardPageItemProductDetail
